import { ReactNode } from 'react';
import { DialogActions, DialogActionsProps } from '@mui/material';

import mergeSx from 'modules/common/utils/mergeSx';

/**
 * Props for FullScreenDialogFooter component
 */
export interface FullScreenDialogFooterProps extends Omit<DialogActionsProps, 'children'> {
    /**
     * Element to render on the left side of the footer
     */
    leftElement?: ReactNode;
    /**
     * Element to render on the right side of the footer
     */
    rightElement?: ReactNode;
}
export default function FullScreenDialogFooter({
    leftElement,
    rightElement,
    sx = undefined,
    ...dialogActionsProps
}: FullScreenDialogFooterProps) {
    if (!leftElement && !rightElement) {
        return null;
    }

    return (
        <DialogActions
            {...dialogActionsProps}
            sx={mergeSx(
                {
                    display: 'flex',
                    justifyContent: leftElement && rightElement ? 'space-between' : 'flex-end',
                },
                sx
            )}>
            {leftElement}
            {rightElement}
        </DialogActions>
    );
}
